import { InjectionToken } from '@angular/core';

import { MetricsDetailLevel } from 'ish-core/models/metrics/metrics-detail-level';
import { createEnvironmentInjectionToken } from 'ish-core/utils/injection';

/**
 * Array of paths that always use mocked data
 */
export const API_MOCK_PATHS = createEnvironmentInjectionToken('apiMockPaths');

/**
 * If 'username' login name is used for registration, if 'email' the email is used as login name (default: 'email')
 */
export const USER_REGISTRATION_LOGIN_TYPE = new InjectionToken<string>('userRegistrationLoginType', {
  factory: () => 'email',
});

/**
 * The maximum subcategories level depth rendered in the main navigation
 */
export const MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH = createEnvironmentInjectionToken(
  'mainNavigationMaxSubCategoriesDepth'
);

/**
 * global definition of the product listing page size
 */
export const PRODUCT_LISTING_ITEMS_PER_PAGE = createEnvironmentInjectionToken('productListingItemsPerPage');

/**
 * default definition of the product listing view type
 */
export const DEFAULT_PRODUCT_LISTING_VIEW_TYPE = createEnvironmentInjectionToken('defaultProductListingViewType');

/**
 * the configured cookie consent options for the application
 */
export const COOKIE_CONSENT_OPTIONS = createEnvironmentInjectionToken('cookieConsentOptions');

/**
 * the configured data retention policy for the application
 */
export const DATA_RETENTION_POLICY = createEnvironmentInjectionToken('dataRetention');

/**
 * the configured price update policy for the application
 */
export const PRICE_UPDATE = createEnvironmentInjectionToken('priceUpdate');

/**
 * the configured theme color
 */
export const THEME_COLOR = createEnvironmentInjectionToken('themeColor');

/**
 * global definition of the Bootstrap grid system breakpoint widths
 */
export const SMALL_BREAKPOINT_WIDTH = createEnvironmentInjectionToken('smallBreakpointWidth');
export const MEDIUM_BREAKPOINT_WIDTH = createEnvironmentInjectionToken('mediumBreakpointWidth');
export const LARGE_BREAKPOINT_WIDTH = createEnvironmentInjectionToken('largeBreakpointWidth');
export const EXTRALARGE_BREAKPOINT_WIDTH = createEnvironmentInjectionToken('extralargeBreakpointWidth');

/**
 * InjectionToken for the metrics detail level configured via environment variable (not environment.ts)
 */
export const METRICS_DETAIL_LEVEL = new InjectionToken<MetricsDetailLevel>('metricsDetailLevel');
